import { 
  FETCH_FONTS_REQUEST, FETCHING_FONTS_SUCCEEDED, FETCHING_FONTS_FAILED,
  INITIATE_FONT_UPLOAD, UPDATE_FONT_UPLOAD_PROGRESS,
  INSTALL_FONTS, UNINSTALL_FONTS, 
  UPLOAD_FONT_REQUEST, UPLOADING_FONT_SUCCEEDED, UPLOADING_FONT_FAILED,
  DELETE_FONT_REQUEST, DELETING_FONT_SUCCEEDED, DELETING_FONT_FAILED, INVALIDATE_FONT_UPLOAD_ERROR
} from 'constants/actionTypes';
import _ from 'lodash';

const initialState = {
  loading: false,
  invalidated: false,
  items: [],
  uploads: [],
  installed: []
}

export function fontReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_FONTS_REQUEST: {
      return {
        ...state,
        loading: true
      }
    }

    case FETCHING_FONTS_SUCCEEDED: {
      return {
        ...state,
        loading: false,
        items: action.payload
      }
    }

    case FETCHING_FONTS_FAILED: {
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    }

    case INITIATE_FONT_UPLOAD: {
      const request = action.payload;
      let { name, type } = request;
      const ttfExtension = name.endsWith('.ttf');

      if (type !== 'font/ttf' && !ttfExtension){
        return {
          ...state,
          uploadError:true,
        }
      }

      var uploads = [...state.uploads, request];
      uploads = _.uniqBy(uploads, 'id');

      return {
        ...state,
        uploads: uploads
      }      
    }
    
    case INVALIDATE_FONT_UPLOAD_ERROR: {
      return {
        ...state,
        uploadError: false,
      }
    }
    
    case UPDATE_FONT_UPLOAD_PROGRESS: {
      const {id, progress} = action.payload;

      var uploads = state.uploads.map(font => {
        if(font.id === id){
          return {
            ...font,
            progress: progress
          }
        }

        return font;
      })

      return {
        ...state,
        uploads: uploads
      }      
    }


    case UPLOAD_FONT_REQUEST:{
      const {id} = action.payload;

      var uploads = state.uploads.map(font => {
        if(font.id === id){
          return {
            ...font,
            processing: true
          }
        }

        return font;
      })

      return {
        ...state,
        uploads: uploads
      }      
    }

    case UPLOADING_FONT_SUCCEEDED:{
      const {id, response} = action.payload;

      var uploads = state.uploads.filter(font => {
        return font.id != id;
      });
      
      var items = [response, ...state.items];
      items = _.uniqBy(items, 'id');
      items = _.orderBy(items, 'createdDate', 'desc');

      return {
        ...state,
        uploads: uploads,
        items
      }      
    }

    case UPLOADING_FONT_FAILED:{
      const {id, error} = action.payload;

      var uploads = state.uploads.map(font => {
        if(font.id === id){
          return {
            ...font,
            processing: false,
            error: error
          }
        }

        return font;
      })

      return {
        ...state,
        uploads: uploads
      }      
    }


    case INSTALL_FONTS: {
      const fonts = action.payload || [];
      const ids = fonts.map(font => font.id);

      var installed = [...state.installed, ...ids];
      _.uniq(installed);

      return {
        ...state,
        installed: installed
      }
    }

    case DELETE_FONT_REQUEST:{
      const id = action.payload;

      var items = state.items.map(font => {
        if(font.id === id){
          return {
            ...font,
            deleting: true
          }
        }

        return font;
      })

      return {
        ...state,
        items: items
      }      
    }

    case DELETING_FONT_SUCCEEDED:{
      const id = action.payload;

      var items = state.items.filter(font => font.id != id);
      var installed = state.installed.filter(font => font != id);

      return {
        ...state,
        items: items,
        installed: installed
      }      
    }

    case DELETING_FONT_FAILED:{
      const {id, error} = action.payload;

      var items = state.items.map(font => {
        if(font.id === id){
          return {
            ...font,
            deleting: false,
            error: error
          }
        }

        return font;
      })

      return {
        ...state,
        items: items
      }      
    }

    default:
      return state;
  }
}